export const calculateProjectStats = data => {
  return {
    total: data?.allGoogleSheetRow?.totalCount || 0,
    status: (data?.allGoogleSheetRow?.nodes || []).reduce((acc, project) => {
      const status =
        project?.Status?.split(/[\s-]+/)
          .map((word, index) =>
            index === 0
              ? word.toLowerCase()
              : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join("") || "unknown"
      acc[status] = (acc[status] || 0) + 1
      return acc
    }, {}),
    types: (data?.allGoogleSheetRow?.nodes || []).reduce((acc, project) => {
      const type =
        project?.Type?.split(/[\s-]+/)
          .map((word, index) =>
            index === 0
              ? word.toLowerCase()
              : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join("") || "unknown"
      acc[type] = (acc[type] || 0) + 1
      return acc
    }, {}),
  }
}
